module.exports = __webpack_public_path__ + "assets/img/2.fd1040f2.png";